export enum FileAccessorType {
    DOWNLOAD_UPLOAD = 'Browser Upload and Download',
    GITHUB = 'Github'
}
